import { render, staticRenderFns } from "./DialogEvaluateStudent.vue?vue&type=template&id=3c62ce1d&scoped=true"
import script from "./DialogEvaluateStudent.vue?vue&type=script&lang=js"
export * from "./DialogEvaluateStudent.vue?vue&type=script&lang=js"
import style0 from "./DialogEvaluateStudent.vue?vue&type=style&index=0&id=3c62ce1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c62ce1d",
  null
  
)

export default component.exports